import { Filter as CommonFilter, FilterProps } from '@otp/ui';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { getFilterConfig } from './config';
import { useStores } from 'src/hooks/query/use-stores';
import { useUsers } from 'src/hooks/query/use-users';

type QuestionnaireResponsesFilterProps = Omit<FilterProps, 'items'> & {
  omitFilterOptions?: string[];
};

export const Filter = ({
  omitFilterOptions,
  ...props
}: QuestionnaireResponsesFilterProps) => {
  const { t } = useTranslation();
  const { stores } = useStores();
  const { users } = useUsers();

  const filterConfig = getFilterConfig({ t, stores, users });
  const filterConfigFiltered = filterConfig.filter(
    (item) => !omitFilterOptions?.includes(item.id),
  );

  return (
    <div className="flex justify-between">
      <CommonFilter
        {...props}
        items={filterConfigFiltered}
        searchInputProps={{
          placeholder: t(
            'wttp.questionnaire-response.list.filter.search.placeholder',
          ),
        }}
      />
    </div>
  );
};
